// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-name-label {
  margin-left: 10px;
  margin-right: 10px; /* Añadir margen a la derecha para separar del botón "Subir Documento" */
}

.input-short {
  max-width: 300px !important; /* Usar max-width y !important para asegurar que se aplique */
  height: 30px; /* Altura explícita para el input */
}

.form-field-group {
  margin-bottom: 15px; /* Ajusta este valor para la separación deseada */
  display: flex; /* Usar flexbox para alinear label e input */
  align-items: center; /* Alinear verticalmente */
  justify-content: flex-start; /* Alinear los elementos al inicio del contenedor */
}

.form-field-group label {
  margin-right: 10px; /* Separación entre el label y el input */
  /* display: flex; */ /* Eliminado, no es necesario para un label */
  line-height: 30px; /* Ajustar line-height para centrar el texto verticalmente con el input */
  height: 30px; /* Altura explícita para el label */
  font-size: 1.1em; /* Aumentar el tamaño de la fuente */
}

.input-wrapper {
  flex-grow: 1; /* Permitir que el wrapper del input ocupe el espacio restante */
  display: flex; /* Usar flexbox para centrar el input dentro de su wrapper */
  justify-content: center; /* Centrar horizontalmente el input */
}

/* Añadir margen derecho al botón secundario para separación */
.p-button-secondary {
  margin-right: 10px;
}

.upload-buttons-container {
  flex-direction: column;
  align-items: flex-start;
}

.upload-buttons-container .p-button {
  margin-bottom: 10px; /* Espacio entre los botones */
}

.upload-buttons-container .file-name-label {
  margin-left: 0; /* Eliminar margen izquierdo si es necesario */
  margin-top: 5px; /* Espacio entre el nombre del archivo y los botones */
}
`, "",{"version":3,"sources":["webpack://./src/styles/UploadDocumento.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB,EAAE,wEAAwE;AAC9F;;AAEA;EACE,2BAA2B,EAAE,6DAA6D;EAC1F,YAAY,EAAE,mCAAmC;AACnD;;AAEA;EACE,mBAAmB,EAAE,iDAAiD;EACtE,aAAa,EAAE,4CAA4C;EAC3D,mBAAmB,EAAE,0BAA0B;EAC/C,2BAA2B,EAAE,mDAAmD;AAClF;;AAEA;EACE,kBAAkB,EAAE,yCAAyC;EAC7D,mBAAmB,EAAE,6CAA6C;EAClE,iBAAiB,EAAE,yEAAyE;EAC5F,YAAY,EAAE,mCAAmC;EACjD,gBAAgB,EAAE,oCAAoC;AACxD;;AAEA;EACE,YAAY,EAAE,gEAAgE;EAC9E,aAAa,EAAE,4DAA4D;EAC3E,uBAAuB,EAAE,qCAAqC;AAChE;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB,EAAE,8BAA8B;AACrD;;AAEA;EACE,cAAc,EAAE,8CAA8C;EAC9D,eAAe,EAAE,sDAAsD;AACzE","sourcesContent":[".file-name-label {\n  margin-left: 10px;\n  margin-right: 10px; /* Añadir margen a la derecha para separar del botón \"Subir Documento\" */\n}\n\n.input-short {\n  max-width: 300px !important; /* Usar max-width y !important para asegurar que se aplique */\n  height: 30px; /* Altura explícita para el input */\n}\n\n.form-field-group {\n  margin-bottom: 15px; /* Ajusta este valor para la separación deseada */\n  display: flex; /* Usar flexbox para alinear label e input */\n  align-items: center; /* Alinear verticalmente */\n  justify-content: flex-start; /* Alinear los elementos al inicio del contenedor */\n}\n\n.form-field-group label {\n  margin-right: 10px; /* Separación entre el label y el input */\n  /* display: flex; */ /* Eliminado, no es necesario para un label */\n  line-height: 30px; /* Ajustar line-height para centrar el texto verticalmente con el input */\n  height: 30px; /* Altura explícita para el label */\n  font-size: 1.1em; /* Aumentar el tamaño de la fuente */\n}\n\n.input-wrapper {\n  flex-grow: 1; /* Permitir que el wrapper del input ocupe el espacio restante */\n  display: flex; /* Usar flexbox para centrar el input dentro de su wrapper */\n  justify-content: center; /* Centrar horizontalmente el input */\n}\n\n/* Añadir margen derecho al botón secundario para separación */\n.p-button-secondary {\n  margin-right: 10px;\n}\n\n.upload-buttons-container {\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.upload-buttons-container .p-button {\n  margin-bottom: 10px; /* Espacio entre los botones */\n}\n\n.upload-buttons-container .file-name-label {\n  margin-left: 0; /* Eliminar margen izquierdo si es necesario */\n  margin-top: 5px; /* Espacio entre el nombre del archivo y los botones */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
